<template>
  <div id="importData">
    <div class="drawer-dimmer" v-if="importingData"></div>
    <p class="mb-1"><strong>Import Data to Existing Blocks</strong><br>You may upload data from a CSV. We recommend downloading a CSV from your farm under the 'Downloads' tab (<i class="fas fa-cloud-download-alt"></i>) to use as a template. Imported data will replace current data and cannot be undone. Use with caution! CSV headers cannot contain any of the following characters: '~', '*', '/', '[', or ']'. To import new blocks, use the 'Create Blocks' button.</p>
    <input
      type="file"
      id="importFile"
      name="importFile"
      value="Import"
      class="mb-2 mt-2"
      accept=".csv"
      @change="selectFile"
    />

    <div
      v-if="machineNames.length > 0"
      class="mt-3"
    >
      <p class="mb-1"><strong>Headers to Sync</strong></p>
      <div
        v-for="(machineName, i) in machineNames"
        v-bind:key="i"
        class="header-pill"
      >
        <b-badge
          v-if="machineName !== 'blockId' && machineName !== 'updatedOn' && machineName !== 'createdOn'"
          pill
          variant="primary"
          class="mr-1"
        >{{ machineName }}</b-badge>
      </div><!-- /v-for -->
    </div><!-- /v-if -->

    <div
      class="list-group mt-3"
      v-if="proposedHeaders.length > 0"
    >
      <p class="mb-1"><strong>New Headers</strong></p>
      <div
        class="list-container"
        v-for="(proposedHeader, index) in proposedHeaders"
        v-bind:key="index"
      >
        <div class="list-group-item mb-2">
          {{ proposedHeader.name }} ({{ proposedHeader.type }})
        </div><!-- /.list-group-item -->
      </div><!-- /.list-container -->
    </div><!-- /.list-group -->

    <div v-if="readyToImport" class="mt-3">
      <b-btn
        v-if="!importingData"
        @click="confirmImportData = true"
        class="btn-primary w-100"
      >
        <i class="fas fa-file-import"></i> Import
      </b-btn>
      <b-btn
        v-else
        class="btn-secondary w-100"
      >
         <i class="fas fa-sync fa-spin"></i> Importing...
      </b-btn>
    </div><!-- /v-if readyToImport -->
    <Confirm
      v-if="confirmImportData"
      text="Are you sure you'd like to import this data? Remember that this will override any existing data and cannot be undone!"
      v-on:confirmed="importData($event)"
    />
  </div><!-- /#importData -->
</template>

<script>
import Confirm from '../Confirm'
import Papa from 'papaparse'
const fb = require('../../firebaseConfig.js')
export default {
  data () {
    return {
      confirmImportData: false,
      importingData: false,
      proposedHeaders: [],
      readyToImport: false,
      jsonData: [],
      headers: [],
      machineNames: [],
      headerTypes: []
    }
  },
  components: {
    Confirm
  },
  computed: {
    farm: {
      get () {
        return this.$store.state.farm
      },
      set (value) {
        this.$store.commit('setStateProperty', { property: 'farm', value: value })
      }
    }
  },
  methods: {
    updateFarm () {
      this.$store.commit('hideDrawer', 'farmDetails')
      this.$store.dispatch('removeAllLayers')
      setTimeout(() => {
        this.$store.dispatch('initFarmMap')
      }, 300)
    },
    selectFile (e) {
      this.headers = []
      this.machineNames = []
      this.proposedHeaders = []
      this.headerTypes = []
      this.readyToImport = false
      this.jsonData = []
      const fileName = e.target.files[0].name
      const lastDot = fileName.lastIndexOf('.')
      const fileExt = fileName.substring(lastDot + 1)
      const reader = new FileReader()
      if (fileExt === 'csv') {
        reader.onload = this.onCSVLoad
        reader.readAsText(event.target.files[0])
      }
    },
    onCSVLoad (e) {
      const obj = Papa.parse(e.target.result, { header: false })
      this.jsonData = obj.data
      this.headers = obj.data[0]
      this.headers.forEach((header, i) => {
        const regex = /[&\/\\#,+()$~%.'":*?<>{}]/g // eslint-disable-line
        const testRegex = regex.test(header)
        if (testRegex) {
          header = header.replace(regex, '_')
        }
        const standardHeaders = [
          'name',
          'description',
          'blockId',
          'updatedOn',
          'updatedBy',
          'createdOn',
          'createdBy'
        ]
        if (standardHeaders.includes(header)) {
          // Check for standard headers
          this.machineNames.push(header)
          this.headerTypes.push('string')
        } else {
          // Check for defined headers if it is a new header, add to proposed headers
          let newProposedHeader = true
          if (this.$store.state.farm.blockFields) {
            this.$store.state.farm.blockFields.forEach(blockField => {
              if (blockField.label === header) {
                this.machineNames.push(blockField.machine_name)
                this.headerTypes.push(blockField.type)
                newProposedHeader = false
              }
            })
          }
          if (newProposedHeader) {
            let headerType = 'Number'
            if (isNaN(this.jsonData[1][i])) {
              headerType = 'Text'
            }
            const proposedHeader = {
              name: header,
              type: headerType
            }
            this.proposedHeaders.push(proposedHeader)
            this.machineNames.push(header)
            this.headerTypes.push(headerType)
          }
        }
      })
      console.log(this.proposedHeaders)
      console.log(this.machineNames)
      console.log(this.headerTypes)
      if (this.jsonData.length > 0) {
        this.readyToImport = true
      }
    },
    importData (e) {
      async function updateBlock (id, obj) {
        console.log(id)
        console.log(obj)
        if (id) {
          await fb.blocksCollection.doc(id).update(obj).then(() => {
            return true
          }).catch(err => {
            console.log(err)
            return true
          })
        } else {
          console.log('DOES NOT PASS')
          return false
        }
      }
      this.confirmImportData = false
      if (e) {
        const updatePromises = []
        this.importingData = true
        this.jsonData.forEach((block, i) => {
          // Skip first header row
          if (i > 0) {
            const blockObject = {
              updatedOn: new Date(),
              updatedBy: this.$store.state.currentUser.uid
            }
            let blockIdVal = false
            console.log(block)
            block.forEach((blockField, me) => {
              const restrictedTerms = [
                'createdBy',
                'createdOn',
                'updatedBy',
                'updatedOn',
                'name',
                'farmId',
                'blockId',
                'footprint',
                'area'
              ]
              if (!restrictedTerms.includes(this.machineNames[me])) {
                if (this.headerTypes[me] === 'Number') {
                  blockObject[this.machineNames[me]] = parseFloat(blockField)
                } else {
                  blockObject[this.machineNames[me]] = blockField
                }
              } else if (this.machineNames[me] === 'blockId') {
                blockIdVal = blockField
              }
            })
            const prom = updateBlock(blockIdVal, blockObject)
            updatePromises.push(prom)
          }
        })
        Promise.all(updatePromises).then(() => {
          console.log('Promises complete')
          this.readyToImport = false
          this.importingData = false
          this.$store.commit('setAlert', { active: true, message: 'Imported data!', level: 'alert-success', timeout: 5000 })

          if (this.proposedHeaders.length > 0) {
            if (!this.farm.blockFields) {
              this.farm.blockFields = []
            }
            console.log('Adding new fields')
            this.proposedHeaders.forEach((proposed, i) => {
              this.farm.blockFields.push({
                label: proposed.name,
                type: proposed.type,
                machine_name: proposed.name,
                min: false,
                max: false,
                options: [],
                step: false,
                suffix: false,
                required: false
              })
            })
          }
          console.log(this.$store.state.farm.id)
          return fb.farmsCollection.doc(this.$store.state.farm.id).update({
            blockFields: this.farm.blockFields || [],
            recompileBlocks: true
          })
        }).then(() => {
          this.updateFarm()
        }).catch(err => {
          console.log(err)
          this.$store.commit('setAlert', { active: true, message: 'Errors importing data!', level: 'alert-danger', timeout: 5000 })
        })
      }
    }
  }
}
</script>

<style scoped>
.header-pill {
  display: inline-block;
}
</style>
